var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2305,-1222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02564,0,0,1.02564,-357.564,-138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2615.5,
    cy: 1345.5,
    r: 19.5,
    style: {
      fill: "rgb(228,228,228)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-52,-140.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2362.86,1396.78C2366.42,1394.91 2371.44,1393.75 2377,1393.75C2382.56,1393.75 2387.58,1394.91 2391.14,1396.78C2387.52,1400.4 2382.52,1402.64 2377,1402.64C2371.48,1402.64 2366.48,1400.4 2362.86,1396.78Z",
    style: {
      fill: "rgb(106,122,136)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.888889,0,0,1.08642,40.5556,-213.654)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2570,
    cy: 1337,
    r: 9,
    style: {
      fill: "rgb(106,122,136)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f74988ba889a0b38f1b8ef3b95355811.svg";
export { ForwardRef as ReactComponent };